import {
    isRollbackRevision,
    REVISION_INFO_PROPERTIES,
    type Revision,
    type RevisionInfo,
} from '../types';
import { getFirstEdit, getLastEdit } from '../utils';

export type MaskedRevision<MaskKey extends keyof Revision> = {
    [key in MaskKey]: Revision[key];
};

/**
 * Apply a mask on a revision to extract properties.
 */
export function extractRevisionByMask<MaskKey extends keyof Revision>(
    input: Revision,
    mask: MaskKey[]
): MaskedRevision<MaskKey> {
    // @ts-ignore
    const result: MaskedRevision<MaskKey> = {};

    mask.forEach((key) => {
        result[key] = input[key];
    });

    return result;
}

/**
 * Extract the revision info from a revision.
 */
export function extractRevisionInfo(input: Revision | RevisionInfo): RevisionInfo {
    // @ts-expect-error
    return extractRevisionByMask<keyof RevisionInfo>(input, REVISION_INFO_PROPERTIES);
}

/**
 * Extracts the revision creation time from the edits.
 *
 * For rollback revisions, it comes from the most recent edit.
 * For other revisions, it comes from the oldest edit.
 */
export function getRevisionCreationTime(revision: RevisionInfo): Date {
    const createdAtEdit = isRollbackRevision(revision)
        ? getLastEdit(revision.edits)
        : getFirstEdit(revision.edits);
    return createdAtEdit ? new Date(createdAtEdit.updatedAt) : new Date();
}
